import { Component, type ErrorInfo, type ReactNode } from 'react';

import ErrorPageShell from './ErrorPageShell';

const isCheckoutMode =
  import.meta.env.VITE_CHECKOUT_MODE === 'true' ||
  (typeof window !== 'undefined' && window.location.hostname === 'pay.zerotail.org');

function homeUrl(): string {
  return isCheckoutMode ? 'https://zerotail.org' : '/';
}

interface Props {
  children: ReactNode;
}

interface State {
  hasError: boolean;
}

export default class ErrorBoundary extends Component<Props, State> {
  state: State = { hasError: false };

  static getDerivedStateFromError(): State {
    return { hasError: true };
  }

  componentDidCatch(error: Error, info: ErrorInfo) {
    console.error('Unhandled render error:', error, info.componentStack);
  }

  render() {
    if (this.state.hasError) {
      return (
        <ErrorPageShell
          title="Something went wrong"
          description="An unexpected error occurred. Try refreshing the page or return home."
        >
          <button
            type="button"
            onClick={() => window.location.assign(homeUrl())}
            className="inline-flex items-center gap-2 rounded-lg border border-zt-border bg-zt-surface/80 px-4 py-2.5 text-sm font-medium text-slate-100 transition hover:border-zt-primary/50 hover:bg-zt-elevated"
          >
            {isCheckoutMode ? 'Go to zerotail.org' : 'Return home'}
          </button>
        </ErrorPageShell>
      );
    }

    return this.props.children;
  }
}
